module.exports = __webpack_public_path__ + "img/w51.dc614d3b.svg";